import { useContext } from 'react';
import { ModalContext } from './ModalContext';
import { AlertCreator } from './useModalCreator';

export function useAlert(): AlertCreator {
  const { alert } = useContext(ModalContext);
  if (alert) {
    return alert;
  } else {
    throw new Error('useAlert must be used within a ModalProvider');
  }
}
